import z from 'zod';

import {BaseVoidResponseSchema} from '@dms/api/shared';

/**
 * Utility
 */
export const ExternalSundrySchema = z.object({
  code: z.string(),
  name: z.string().nullish(),
  type: z.string().nullish(),
  specification: z.string().nullish(),
  unit: z.string().nullish(),
});
export type ExternalSundry = z.infer<typeof ExternalSundrySchema>;

/**
 * GET
 */
export const GetSelectableMaterialRequestSchema = z.object({
  selectableMaterialId: z.string(),
});
export type GetSelectableMaterialRequest = z.infer<typeof GetSelectableMaterialRequestSchema>;

export const GetSelectableMaterialResponseSchema = z.object({
  integrationId: z.string(),
  note: z.string().nullish(),
});
export type GetSelectableMaterialResponse = z.infer<typeof GetSelectableMaterialResponseSchema>;

export const GetSelectableMaterialItemsRequestSchema = z.object({
  selectableMaterialId: z.string(),
  selectableMaterialItemId: z.string(),
});
export type GetSelectableMaterialItemsRequest = z.infer<
  typeof GetSelectableMaterialItemsRequestSchema
>;

export const GetSelectableMaterialItemResponseSchema = z.object({
  authorizationProfileIds: z.array(z.string()),
  externalSundry: ExternalSundrySchema,
  warehouseArticleId: z.string().nullish(),
});
export type GetSelectableMaterialItemResponse = z.infer<
  typeof GetSelectableMaterialItemResponseSchema
>;

/**
 * POST
 */
export const PostSelectableMaterialRequestSchema = z.object({
  integrationId: z.string(),
  note: z.string().nullish(),
});
export type PostSelectableMaterialRequest = z.infer<typeof PostSelectableMaterialRequestSchema>;

export const PostSelectableMaterialResponseSchema = z.object({
  selectableMaterialId: z.string(),
});
export type PostSelectableMaterialResponse = z.infer<typeof PostSelectableMaterialResponseSchema>;

export const PostSelectableMaterialItemRequestSchema = z.object({
  selectableMaterialId: z.string(),
  body: z.object({
    authorizationProfileIds: z.array(z.string()).nullish(),
    externalSundry: ExternalSundrySchema,
    warehouseArticleId: z.string().nullish(),
  }),
});
export type PostSelectableMaterialItemRequest = z.infer<
  typeof PostSelectableMaterialItemRequestSchema
>;

export const PostSelectableMaterialItemResponseSchema = z.object({
  selectableMaterialItemId: z.string(),
});
export type PostSelectableMaterialItemResponse = z.infer<
  typeof PostSelectableMaterialItemResponseSchema
>;

export const PostSelectableMaterialItemPairRequestSchema = z.object({
  selectableMaterialId: z.string(),
  body: z.object({
    selectableMaterialItemIds: z.array(z.string()),
    warehouseArticleId: z.string(),
  }),
});
export type PostSelectableMaterialItemPairRequest = z.infer<
  typeof PostSelectableMaterialItemPairRequestSchema
>;

export const PostSelectableMaterialItemPairResponseSchema = BaseVoidResponseSchema;
export type PostSelectableMaterialItemPairResponse = z.infer<
  typeof PostSelectableMaterialItemPairResponseSchema
>;

export const PostSelectableMaterialItemUnpairRequestSchema = z.object({
  selectableMaterialId: z.string(),
  body: z.object({
    selectableMaterialItemIds: z.array(z.string()),
  }),
});
export type PostSelectableMaterialItemUnpairRequest = z.infer<
  typeof PostSelectableMaterialItemUnpairRequestSchema
>;

export const PostSelectableMaterialItemUnpairResponseSchema = BaseVoidResponseSchema;
export type PostSelectableMaterialItemUnpairResponse = z.infer<
  typeof PostSelectableMaterialItemUnpairResponseSchema
>;

/**
 * PATCH
 */
export const PatchSelectableMaterialItemRequestSchema = z.object({
  selectableMaterialId: z.string(),
  selectableMaterialItemId: z.string(),
  body: z.object({
    authorizationProfileIds: z.array(z.string()).nullish(),
    externalSundry: ExternalSundrySchema,
  }),
});
export type PatchSelectableMaterialItemRequest = z.infer<
  typeof PatchSelectableMaterialItemRequestSchema
>;

export const PatchSelectableMaterialItemResponseSchema = BaseVoidResponseSchema;
export type PatchSelectableMaterialItemResponse = z.infer<
  typeof PatchSelectableMaterialItemResponseSchema
>;

/**
 * DELETE
 */
export const DeleteSelectableMaterialRequestSchema = z.object({
  selectableMaterialId: z.string(),
});
export type DeleteSelectableMaterialRequest = z.infer<typeof DeleteSelectableMaterialRequestSchema>;

export const DeleteSelectableMaterialResponseSchema = BaseVoidResponseSchema;
export type DeleteSelectableMaterialResponse = z.infer<
  typeof DeleteSelectableMaterialResponseSchema
>;

export const DeleteSelectableMaterialItemRequestSchema = z.object({
  selectableMaterialId: z.string(),
  body: z.object({
    selectableMaterialItemIds: z.array(z.string()),
  }),
});
export type DeleteSelectableMaterialItemRequest = z.infer<
  typeof DeleteSelectableMaterialItemRequestSchema
>;

export const DeleteSelectableMaterialItemResponseSchema = BaseVoidResponseSchema;
export type DeleteSelectableMaterialItemResponse = z.infer<
  typeof DeleteSelectableMaterialItemResponseSchema
>;
